<template>
  <div class="n-forms">
    <HeadLine>
      {{$ml.get('n-forms')}}
    </HeadLine>
    <table class="th-table">
      <tr>
        <td class="col">
          {{$ml.get('Elements')}}
        </td>
        <td class="nut">
          NNO3
        </td>
        <td class="nut">
          NNH4
        </td>
      </tr>

      <tr>
        <td class="col">
          {{$ml.get('Test Result')}}
        </td>
        <td>
          {{ $store.getters['unit/convert'](unit, section.data.data.values['NO3_Val']) }} {{ $ml.get($store.getters['unit/getLabel'](unit)) }}
        </td>
        <td>
          {{ $store.getters['unit/convert'](unit, section.data.data.values['NH4_Val']) }} {{ $ml.get($store.getters['unit/getLabel'](unit)) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
import ValueField from './../../components/common/ValueField';
export default {
  computed: {
    section() {
      return this.$root.data.waterTest;
    },
    unit() {
      return this.$root?.data?.program?.type == 'soil-based' ? 'kg' : 'ppm';
    }
  },
  components: {
    HeadLine,
    ValueField,
  },
}
</script>

<style lang="scss" scoped>

.n-forms {
  .head-line {
    margin-bottom: 10px;
  }

  .th-fields-container {
    margin-bottom: 20px;
  }

  table {
    border: 0;
    tr {
      td {
        background: #fff !important;
        &.col {
          color: #8E8E8E;
          font-weight: normal;
        }
        &.nut {
          font-weight: bold;
        }
      }
      &:first-child {
        td {
          border-bottom: 1px solid #C4C4C4;
        }
      }
    }
  }
}

</style>